import request from 'services/request'
import { ResponseBase } from 'services/responseBase'
import { ThirdLoginParams } from 'services/types/User'

// 获取三方登录路径
export function getThirdLoginUrl(type: string): Promise<ResponseBase> {
  return request.get<ResponseBase>(`user/thirdLogin/v1/getThirdLoginUrl?type=${type}`)
}
// 用户谷歌/facebook/apple登录
export function thirdLogin(type: string, params: ThirdLoginParams): Promise<ResponseBase> {
  return request.post<ResponseBase>(`user/thirdLogin/v1/user${type}Login`, params)
}
// 用户三方注册
export function thirdRegister(
  email: string,
  randomCode: string,
  recaptchaToken: string,
  referrerUrl: string
): Promise<ResponseBase> {
  return request.post<ResponseBase>('user/thirdLogin/v1/userThirdRegister', {
    email,
    randomCode,
    recaptchaToken,
    referrerUrl,
  })
}
// 三方注册邮箱验证
export function thirdRegisterEmailVerify(emailCode: string, randomCode: string): Promise<ResponseBase> {
  return request.post<ResponseBase>('user/thirdLogin/v1/thirdRegisterEmailValidator', { emailCode, randomCode })
}
// 三方注册重新发验证码
export function thirdRegisterResendEmail(randomCode: string): Promise<ResponseBase> {
  return request.post<ResponseBase>(`user/thirdLogin/v1/resend-code/${randomCode}`)
}
// 三方账户换绑
export function thirdAccountExchange(randomCode: string): Promise<ResponseBase> {
  return request.post<ResponseBase>('user/thirdLogin/v1/thirdAccountExchange', { randomCode })
}
